module.exports = __webpack_public_path__ + "static/media/image_A9.d02d7071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog_images/image_A9.png
// module id = 2261
// module chunks = 0